var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.componentParsedName,{tag:"component",attrs:{"items":_vm.items,"image":_vm.image,"text":_vm.text,"title":_vm.title,"classes":_setup.classes,"top-content":_vm.topContent,"bottom-content":_vm.bottomContent,"is-home-page":_vm.isHomePage,"is-in-expandable-tab":_vm.isInExpandableTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }